var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.969001 19.531C0.899156 19.4613 0.843742 19.3786 0.805932 19.2874C0.768123 19.1963 0.74866 19.0986 0.74866 19C0.74866 18.9013 0.768123 18.8037 0.805932 18.7125C0.843742 18.6214 0.899156 18.5387 0.969001 18.469L9.4395 9.99999L0.969001 1.53099C0.828171 1.39016 0.749054 1.19915 0.749054 0.999987C0.749054 0.800823 0.828171 0.609818 0.969001 0.468987C1.10983 0.328157 1.30084 0.249041 1.5 0.249041C1.69916 0.249041 1.89017 0.328157 2.031 0.468987L11.031 9.46899C11.1008 9.53866 11.1563 9.62142 11.1941 9.71254C11.2319 9.80365 11.2513 9.90134 11.2513 9.99999C11.2513 10.0986 11.2319 10.1963 11.1941 10.2874C11.1563 10.3786 11.1008 10.4613 11.031 10.531L2.031 19.531C1.96133 19.6008 1.87857 19.6562 1.78745 19.6941C1.69633 19.7319 1.59865 19.7513 1.5 19.7513C1.40135 19.7513 1.30367 19.7319 1.21255 19.6941C1.12143 19.6562 1.03867 19.6008 0.969001 19.531Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.40c3c1d7e9484df0bb1cafb9cc0e4782.svg";
export { ForwardRef as ReactComponent };